import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./Components/Navbar/Navbar";
import MobileNav from "./Components/MobileNav/MobileNav";
import Login from "./Components/LoginPage/Login";
import LandingPage from "./Pages/LandingPage/LandingPage";
import ExpertView from "./Pages/ExpertView/ExpertView";
import Publisher from "./Components/Publisher/Publisher";
import MyView from "./Pages/MyView/MyView";
import "./App.scss";

function Layout() {
  const location = useLocation();

  const hideNavbar = location.pathname === "/login";

  return (
    <>
      {!hideNavbar && <Navbar />}

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/expertview" element={<ExpertView />} />
        <Route path="/MyView" element={<MyView />} />
        <Route path="/login" element={<Login />} />
        <Route path="/publisher" element={<Publisher />} />
      </Routes>

      {!hideNavbar && <MobileNav />}
    </>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;